import { useBreakoutUser } from 'hooks/profile'
import { observer } from 'mobx-react-lite'
import { PromotionSelectionWidget } from 'pages/instructor/classes/PromotionSelectionWidget'

export const SectionPromotionConfiguration = observer(
  function SectionConfiguration({
    onSelectedUserPromotionIdsChange,
  }: {
    onSelectedUserPromotionIdsChange: (ids: string[]) => void
  }) {
    const user = useBreakoutUser()

    return (
      <div className="flex min-h-full w-full flex-col items-start justify-center">
        <div className="w-full">
          {user.userPromotions.isLoaded && (
            <PromotionSelectionWidget
              onChange={onSelectedUserPromotionIdsChange}
              kind="tertiary"
            />
          )}
        </div>
      </div>
    )
  }
)
